import Keycloak from 'keycloak-js'

class AuthentificationService {
  constructor () {
    this.sso = Keycloak()
  }

  init () {
    return new Promise((resolve, reject) => {
      this.sso
        .init()
        .success(isAuthenticated => resolve(isAuthenticated))
        .error(error => reject(error))
    })
  }

  logIn () {
    return new Promise((resolve, reject) => {
      this.sso
        .login()
        .success(() => resolve())
        .error(() => reject(new Error('Failed to log in.')))
    })
  }

  logOut () {
    return new Promise((resolve, reject) => {
      this.sso
        .logout()
        .success(() => resolve())
        .error(() => reject(new Error('Failed to log out.')))
    })
  }

  getConnectedUser () {
    return new Promise((resolve, reject) => {
      this.sso
        .loadUserInfo()
        .success(user => resolve(user))
        .error(() => reject(new Error('Failed to get connected user.')))
    })
  }

  getToken () {
    console.log(this.sso.idToken)
    return this.sso.idToken
  }
}

export default new AuthentificationService()
